import React from 'react';
import { useTranslation } from 'react-i18next';
import { di } from '../../state/inversify.config';
import { useQuerySync } from '../../state/queryParams/useQuerySync';
import { GlobalQueryParams } from '../../state/queryParams/queryParams.interface';
import { CreateIncidentQueryService } from './createIncident.queryParam.service';
import { IncidentCreatedSuccessfully } from './smart/incidentCreatedSuccessfully.smart';
import { ReviewIncidentSmart } from './smart/reviewIncident.smart';
import { CheckRedFlagsSmart } from './smart/checkRedFlags.smart';
import { CompleteIncidentSmart } from './smart/completeIncident.smart';
import { PlayerListSmart } from './smart/playerList.smart';
import { IncidentStepperQuery } from './incidentStepper.interface';
import { ReportIncidentSmart } from './smart/reportIncident.smart';
import { CreateIncidentDomainService } from './createIncidentDomainService';

export const CreateIncidentPage = () => {
  const { t } = useTranslation();

  const createIncidentQueryService = di.get<CreateIncidentQueryService>(
    CreateIncidentQueryService,
  );
  useQuerySync<IncidentStepperQuery & GlobalQueryParams>(
    createIncidentQueryService,
  );

  const createIncidentDomainService = di.get<CreateIncidentDomainService>(
    CreateIncidentDomainService,
  );
  const activeStep = createIncidentDomainService.useActiveStepSelector();

  return (
    <>
      {activeStep === 0 && <PlayerListSmart />}
      {activeStep === 1 && (
        <ReportIncidentSmart
          symptomQuestion={t('incident.INCIDENT_REPORT_CHECK_RED_FLAGS')}
          goBackText={t('common.generic.GENERIC_NAVIGATION_BACK').toString()}
          goNextText={t(
            'incident.INCIDENT_REPORT_NEXT_COMPLETE_INCIDENT',
          ).toString()}
        >
          <CheckRedFlagsSmart />
        </ReportIncidentSmart>
      )}
      {activeStep === 2 && (
        <ReportIncidentSmart
          symptomQuestion={t(
            'incident.INCIDENT_REPORT_COMPLETE_INCIDENT_DESCRIPTION',
          ).toString()}
          goBackText={t('common.generic.GENERIC_NAVIGATION_BACK').toString()}
          goNextText={t(
            'incident.INCIDENT_REPORT_NEXT_REVIEW_SUBMIT',
          ).toString()}
        >
          <CompleteIncidentSmart />
        </ReportIncidentSmart>
      )}
      {activeStep === 3 && (
        <ReportIncidentSmart
          symptomQuestion={t(
            'incident.INCIDENT_REPORT_REVIEW_SUBMIT_NOTIFY',
          ).toString()}
          goNextText={t(
            'incident.INCIDENT_REPORT_SUBMIT_NOTIFY_AGAIN',
          ).toString()}
        >
          <ReviewIncidentSmart />
        </ReportIncidentSmart>
      )}
      {activeStep === 4 && <IncidentCreatedSuccessfully />}
    </>
  );
};
